<div class="main-content">
  <div class="container-fluid">
    <div *ngIf="loading" class="text-center">
      <mat-spinner diameter="40" style="margin: 20px auto;"></mat-spinner>
    </div>

    <div *ngIf="!loading && performance">
      <!-- Back Button -->
      <div class="row">
        <div class="col-md-12">
          <button mat-raised-button class="btn btn-default btn-round btn-link"
                  [routerLink]="['/observability/seo/offPagePerformance']">
            <i class="material-icons">arrow_back</i> Back to List
          </button>
        </div>
      </div>

      <!-- Block 1: Basic Data -->
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header card-header-info">
              <h4 class="card-title">{{ performance.campaignId.title }}</h4>
              <p class="card-category">Basic Campaign Information</p>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <p class="text-muted mb-1 small">Target Keyword(s)</p>
                  <div class="keyword-display" (click)="showModal('Keywords', getKeywords(performance))" style="cursor: pointer;" title="Click to view all keywords">
                    <p class="font-weight-bold mb-0">
                      {{ getKeywords(performance)[0] }}
                      <small *ngIf="getKeywords(performance).length > 1" class="text-muted">
                        (+{{ getKeywords(performance).length - 1 }})
                      </small>
                    </p>
                  </div>
                </div>

                <div class="col-md-8">
                  <p class="text-muted mb-1 small">Target URL</p>
                  <a [href]="performance.targetUrl" target="_blank" class="text-info font-weight-bold">
                    {{ performance.targetUrl }} <i class="material-icons" style="font-size: 14px;">open_in_new</i>
                  </a>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-3">
                  <p class="text-muted mb-1 small">Status</p>
                  <span class="badge" [ngClass]="{
                    'badge-info': performance.campaignId.status === 'in_progress',
                    'badge-success': performance.campaignId.status === 'completed',
                    'badge-warning': performance.campaignId.status === 'approved',
                    'badge-default': performance.campaignId.status === 'planned'
                  }">{{ performance.campaignId.status | uppercase }}</span>
                </div>
                <div class="col-md-3">
                  <p class="text-muted mb-1 small">City</p>
                  <p>{{ performance.campaignId.city || '-' }}</p>
                </div>
                <div class="col-md-3">
                  <p class="text-muted mb-1 small">Type</p>
                  <p>{{ performance.campaignId.campaignType | titlecase }}</p>
                </div>
                <div class="col-md-3">
                  <p class="text-muted mb-1 small">Priority</p>
                  <p>{{ performance.campaignId.priority | titlecase }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Block 2: Performance Summary -->
        <div class="col-md-4">
          <div class="card card-profile">
            <div class="card-avatar">
              <div class="impact-score-circle" [ngClass]="{
                'health-excellent': performance.healthStatus === 'excellent',
                'health-good': performance.healthStatus === 'good',
                'health-watch': performance.healthStatus === 'watch',
                'health-poor': performance.healthStatus === 'poor'
              }">
                {{ performance.impactScore }}
              </div>
            </div>
            <div class="card-body">
              <h6 class="card-category text-gray">Impact Score</h6>
              <h4 class="card-title">{{ performance.healthStatus | uppercase }}</h4>
              <p class="card-description">
                Confidence: <strong>{{ performance.attributionConfidence | titlecase }}</strong>
              </p>
              <div class="row text-center mt-3">
                <div class="col-6">
                  <p class="text-muted mb-0 small">Conversion</p>
                  <p class="font-weight-bold">{{ (performance.conversionRate * 100).toFixed(1) }}%</p>
                </div>
                <div class="col-6">
                  <p class="text-muted mb-0 small">Live Links</p>
                  <p class="font-weight-bold">{{ performance.backlinksLiveCount }}</p>
                </div>
              </div>
              <div class="row text-center mt-2">
                <div class="col-6">
                  <p class="text-muted mb-0 small">Pos Δ</p>
                  <p class="font-weight-bold" [ngClass]="performance.positionDelta > 0 ? 'text-success' : 'text-danger'">
                    {{ performance.positionDelta > 0 ? '+' : '' }}{{ performance.positionDelta.toFixed(2) }}
                  </p>
                </div>
                <div class="col-6">
                  <p class="text-muted mb-0 small">Clicks Δ</p>
                  <p class="font-weight-bold" [ngClass]="performance.clicksDelta > 0 ? 'text-success' : 'text-danger'">
                    {{ performance.clicksDelta > 0 ? '+' : '' }}{{ performance.clicksDelta }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Block 3: Snapshot History -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header card-header-primary">
              <h4 class="card-title">Snapshot History</h4>
              <p class="card-category">Historical performance data points</p>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table mat-table [dataSource]="snapshots" class="table">

                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef>Snapshot Date</th>
                    <td mat-cell *matCellDef="let element">{{ element.snapshotDate | date:'medium' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="impactScore">
                    <th mat-header-cell *matHeaderCellDef>Impact</th>
                    <td mat-cell *matCellDef="let element">
                      <span class="badge badge-info">{{ element.impactScore }}</span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="position">
                    <th mat-header-cell *matHeaderCellDef>Position (Before -> After)</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.positionBefore.toFixed(2) }} <i class="material-icons small-icon">arrow_forward</i> {{ element.positionAfter.toFixed(2) }}
                      <small class="ml-1" [ngClass]="element.positionDelta > 0 ? 'text-success' : 'text-danger'">
                        ({{ element.positionDelta > 0 ? '+' : '' }}{{ element.positionDelta.toFixed(2) }})
                      </small>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="clicks">
                    <th mat-header-cell *matHeaderCellDef>Clicks (Before -> After)</th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.clicksBefore }} <i class="material-icons small-icon">arrow_forward</i> {{ element.clicksAfter }}
                      <small class="ml-1" [ngClass]="element.clicksDelta > 0 ? 'text-success' : 'text-danger'">
                        ({{ element.clicksDelta > 0 ? '+' : '' }}{{ element.clicksDelta }})
                      </small>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="summary">
                    <th mat-header-cell *matHeaderCellDef>Summary</th>
                    <td mat-cell *matCellDef="let element">
                      <small>{{ element.summary }}</small>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="snapshotColumns"></tr>
                  <tr mat-row *matRowDef="let element; columns: snapshotColumns;"></tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent || modalListItems" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div class="modal-url-body text-dark" style="word-wrap: break-word; white-space: pre-wrap">
      <ng-container *ngIf="modalContent">
        {{ modalContent }}
      </ng-container>
      <ul *ngIf="modalListItems" class="ps-3 mb-0">
        <li *ngFor="let kw of modalListItems" style="padding-bottom: 4px">
          {{ kw }}
        </li>
      </ul>
    </div>
  </div>
</div>

